<template>
  <v-dialog
    v-model="mainDialog"
    v-if="user"
    @input="dismiss()"
    scrollable
    max-width="300px"
  >
    <v-card color="rgb(20,20,20)" dark class="rounded-lg">
      <v-btn icon class="ma-2" @click="dismiss()"
        ><v-icon>mdi-close</v-icon></v-btn
      >
      <v-card-text class="pr-2 pl-2 pt-2 pb-2 text-center white--text">
        <v-btn
          color="grey darken-3"
          class="elevation-0"
          v-blur
          fab
          small
          style="
            z-index: 4;
            position: absolute;
            top: 75px;
            right: 75px;
            border: 5px solid rgb(20, 20, 20) !important;
          "
          @click="uploadImage()"
        >
          <v-icon size="18">mdi-image-edit</v-icon>
        </v-btn>
        <v-avatar
          width="128px"
          height="128px"
          class="mt-4 mb-4"
          :color="user.avatar ? '' : 'rgb(40,40,40)'"
        >
          <img v-if="user.avatar" :src="user.avatar" />
          <span v-else class="white--text text-h3">{{
            user.username.substring(0, 2)
          }}</span>
        </v-avatar>
        <p class="title">
          {{ user.username }}
          <v-tooltip bottom v-if="user.tier == 'Friend'">
            <template v-slot:activator="{ on }">
              <v-icon
                style="position: absolute"
                class="ml-2 mt-1"
                v-on="on"
                color="orange accent-4"
                >mdi-check-outline</v-icon
              >
            </template>
            <span>Friend</span>
          </v-tooltip>
          <v-tooltip bottom v-if="user.tier == 'Supporter'">
            <template v-slot:activator="{ on }">
              <v-icon
                style="position: absolute"
                class="ml-2 mt-1"
                v-on="on"
                color="orange accent-4"
                >mdi-check</v-icon
              >
            </template>
            <span>Supporter</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="user.tier == 'Advocate'">
            <template v-slot:activator="{ on }">
              <v-icon
                style="position: absolute"
                class="ml-2 mt-1"
                v-on="on"
                color="orange accent-4"
                >mdi-check-all</v-icon
              >
            </template>
            <span>Advocate</span>
          </v-tooltip>
        </p>
        <p class="text-subtitle-2 grey--text mb-6">
          {{ user.email.address }}
          <v-tooltip bottom v-if="user.email.verified">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-shield-check</v-icon>
            </template>
            <span>Verified</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="clickable" @click="verifyEmail()"
                >mdi-shield-alert</v-icon
              >
            </template>
            <span>Click to resend verification email.</span>
          </v-tooltip>
        </p>
        <v-btn color="red accent-4" width="50%" class="mb-12" @click="logout()">
          Logout
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
}

::-webkit-scrollbar-track {
  background: rgb(230, 230, 230) !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(190, 190, 190) !important;
  border-radius: 40px !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(170, 170, 170) !important;
}
</style>

<script>
export default {
  data: () => ({
    mainDialog: false
  }),
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    dismiss() {
      this.mainDialog = false;
    },
    open() {
      this.mainDialog = true;
    },
    logout() {
      this.dismiss();
      this.$nextTick(() => {
        this.$root.logout();
      }, 10);
    },
    uploadImage() {
      let input = document.createElement("input");
      input.type = "file";

      let $this = this;

      input.onchange = e => {
        let file = e.target.files[0];

        let reader = new FileReader();
        reader.readAsDataURL(file); // this is reading as data url

        reader.onload = readerEvent => {
          let image = new Image();
          image.src = readerEvent.target.result;

          image.onload = function() {
            let canvas = document.createElement("canvas");
            canvas.width = 128;
            canvas.height = 128;

            canvas
              .getContext("2d")
              .drawImage(image, 0, 0, canvas.width, canvas.height);
            let dataUrl = canvas.toDataURL("image/png");

            console.log(dataUrl); //eslint-disable-line

            $this.$socket.emit(
              "update avatar",
              {
                userID: $this.user.id,
                token: localStorage.getItem("token"),
                newAvatar: dataUrl
              },
              valid => {
                if (!valid) {
                  $this.$root.$alert("Error", "Invalid avatar.", {
                    color: "red accent-4"
                  });
                } else {
                  $this.user.avatar = dataUrl;
                }
              }
            );
          };
        };
      };

      input.click();
    },

    verifyEmail() {
      this.$socket.emit(
        "resend verification email",
        {
          userID: this.user.id,
          token: localStorage.getItem("token")
        },
        output => {
          if (output.success == true) {
            this.$root.$alert(
              "Success",
              "Verification email resent to <b>" +
                this.user.email.address +
                " </b>."
            );
          } else {
            switch (output.code) {
              case 0:
                this.$root.$alert(
                  "Unknown Error",
                  "Unable to resend verification email. Please try again later",
                  {
                    color: "red accent-4"
                  }
                );
                break;
              case 1:
                this.$root.$alert(
                  "Error",
                  "You're doing that too much! Try again later.",
                  {
                    color: "red accent-4"
                  }
                );
                break;
            }
          }
        }
      );
    }
  }
};
</script>
